import CryptoJS from "crypto-js";

export class Digest {
    static defaultAlgs = ['sha1', 'sha256', 'sha384', 'sha512'];

    constructor(alg, hash) {
        this.alg = alg;
        this.hash = hash;
    }

    static async fromFile(file, algsStrs, progress) {
        const sliceSize = 1024 * 1024;
        let readed = 0;
        const total = file.size;
        const hashers = algsStrs.map(hasherCreate);
        while (readed < file.size) {
            const slice = await readSlice(file, readed, sliceSize);
            const wordArray = CryptoJS.lib.WordArray.create(slice);
            for (const hasher of hashers) {
                hasher.update(wordArray);
            }
            readed += slice.byteLength;
            progress(readed, total);
        }

        return hashers.map((hasher, i) => {
            const hash = hasher.finalize().toString();
            
            return new Digest(algsStrs[i], hash);
        });
    }
}

function hasherCreate(alg) {
    switch (alg) {
        case 'sha1': return CryptoJS.algo.SHA1.create();
        case 'sha256': return CryptoJS.algo.SHA256.create();
        case 'sha384': return CryptoJS.algo.SHA384.create();
        case 'sha512': return CryptoJS.algo.SHA512.create();
        default: return CryptoJS.algo.SHA256.create();
    }
}

async function readSlice(file, start, size) {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        const slice = file.slice(start, start + size);
        fileReader.onload = () => {
            const arrayBuffer = fileReader.result;
            const res = new Uint8Array(arrayBuffer);
            resolve(res);
        };
        fileReader.onerror = reject;
        fileReader.readAsArrayBuffer(slice);
    });
}
